module.exports = __webpack_public_path__ + "static/media/ico-new-especialidades.3d74948f.svg";